/*
    Author:fanglijuan
    Time:2017-04-25
*/
"use strict";
angular.module("productManageMentClassifyDelModule", [])
    .controller("productManageMentClassifyDelCtrl", ["$scope", "$modalInstance", "$stateParams", "trsspliceString", "trsHttpService", "delItems", "title",function($scope, $modalInstance, $stateParams, trsspliceString, trsHttpService, delItems, title) {
        initData();
        function initData() {
            $scope.delItems = delItems;
            $scope.title = title;
        }

        $scope.cancel = function() {
            $modalInstance.dismiss("cancel");
        };

        $scope.delete = function() {
            $modalInstance.close("success");
        };
    }]);
